import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Seo from "@/components/base/Seo";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Seo
        title="页面走丢了 - 51吃瓜"
        description="这个页面不存在或已被移动，返回51吃瓜首页看看今天有什么瓜吧。"
        keywords="51吃瓜,今日新鲜瓜,页面不存在"
        path={location.pathname}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "页面走丢了 - 51吃瓜",
        }}
      />
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 pt-28 pb-20">
        <div className="text-center max-w-lg">
          <p className="font-heading font-black text-7xl md:text-9xl text-primary-200 select-none">
            404
          </p>
          <h1 className="mt-4 font-heading font-black text-2xl md:text-3xl text-foreground-950">
            这页瓜田还没长出来
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            你访问的地址不存在或已经被移动，不如去首页看看今天有什么新瓜。
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/rank"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-primary-300 text-primary-600 text-sm hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              <i className="ri-fire-line"></i>
              查看热瓜榜
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}